<script setup lang="ts">
import { useField } from 'vee-validate'

const originalProps = defineProps<{
  name: string
  default?: boolean
  label?: string
  items?: {
    value: string
    text?: string
    label?: string
    logo?: StoryBlokImage
  }[]
  tooltip?: StoryBlokTooltip[]
  description?: string
  disableStoryblok?: boolean
}>()
const emit = defineEmits(['changed'])
const ga4 = useAnalytics()
const props = originalProps.disableStoryblok ? originalProps : useStoryblokProps(originalProps)
const { value: modelValue } = useField<boolean | string>(props.name, undefined, {
  type: 'radio',
})

function clickEvent(selectedValue: string) {
  modelValue.value = selectedValue
  emit('changed', selectedValue)
  ga4.trackEvent({
    event_action: 'radio',
    event_label: originalProps?.name,
  })
}
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
}
</script>

<template>
  <div>
    <BaseLabel v-if="props.label" :tooltip="props.tooltip">
      {{ props.label }}
    </BaseLabel>
    <div :class="$attrs.class">
      <div v-for="item in props.items" :key="item.value" class="flex items-center gap-2.5 cursor-pointer group pb-1" @click="clickEvent(item.value)">
        <div
          :data-test-id="`FieldRadioGroup|${name}|${item.value}`"
          class="min-w-6 h-6 rounded-full border-1 group-hover:border-hover duration-200 border-gray grid place-items-center transition-colors"
          :class="[(modelValue?.toString() === item.value) ? 'bg-primary border-primary' : 'bg-white']"
        >
          <div v-if="modelValue?.toString() === item.value" class="w-2.5 h-2.5 rounded-full bg-white" />
        </div>
        <input v-model="modelValue" :value="item.value" type="radio" :name="name" hidden>
        <div class="flex flex-col">
          <span>{{ item.text || item.label }}</span>
          <span class="text-gray-dark">{{ props.description }}</span>
        </div>
        <StoryblokImage
          v-if="item.logo?.filename"
          height="16"
          :src="item.logo"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
